import { ErrorManagementVendorErrorCodesApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const vendorErrorCodesApi = new ErrorManagementVendorErrorCodesApi(
  config,
);

export const vendorErrorCodesRequestInit = {
  credentials: 'include' as const,
};
